import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=064eb8c1"
import script from "./sitemap.vue?vue&type=script&lang=ts"
export * from "./sitemap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064eb8c1')) {
      api.createRecord('064eb8c1', component.options)
    } else {
      api.reload('064eb8c1', component.options)
    }
    module.hot.accept("./sitemap.vue?vue&type=template&id=064eb8c1", function () {
      api.rerender('064eb8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "templates/sitemap.vue"
export default component.exports